/**
 * @fileoverview Barrel exports for the short-story-extractor agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export { InputSchema, OutputSchema, type Input, type Output } from './schema';

// Flow
export { flow } from './flow';

// Prompt template
export { prompt } from './prompt';
